"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnEntityModified = void 0;
/**
 * @public
 * Emit on a plot to indicate that an entity has been modified and that caches should be regenerated. Refer to the group's
 * documentation as to the conditions where this is required.
 */
class OnEntityModified {
    constructor(onEntityModified) {
        this.onEntityModified = onEntityModified;
    }
    static registerListener(plot, onEvent) {
        return plot.eventService
            .getCategory(OnEntityModified)
            .addTemporaryListener(new OnEntityModified(onEvent));
    }
    static registerOneTimeListener(plot, onEvent) {
        return plot.eventService
            .getCategory(OnEntityModified)
            .addOneTimeListener(new OnEntityModified(onEvent));
    }
    static emit(plot, entity) {
        const listeners = plot.eventService
            .getCategory(OnEntityModified)
            .getTargets();
        for (let i = 0, iEnd = listeners.length; i < iEnd; ++i) {
            listeners[i].onEntityModified(entity, plot);
        }
    }
}
exports.OnEntityModified = OnEntityModified;
OnEntityModified.callbackKey = "onEntityModified";
//# sourceMappingURL=on-entity-modified.js.map